<template lang="pug">
  .recommendations.container
    .row.xs-f-small.max-at-tweak
      .fixed-width-tweak-upper
        .xs-12
          h1.xs-f-large.lg-f-xxlarge.text-center.max-at-tweak(
            v-if="(hairGoalRecs.colorIssue && hairGoalRecs.colorIssue != 'nothing') || hairGoalRecs.trendsAndTips")
            | Recommended for you...
          RecommendationPanel(title="You mentioned wanting better <strong>gray coverage</strong>"
                              preamble="Choose a shade that's tough on grays.  We recommend the following:"
                              :actions=`[ {
                                label: isSubscribedToRecommendedColor ? "Added" : "Update Subscription",
                                action: isSubscribedToRecommendedColor ? goToManageSubscription : updateSubscription,
                                checked: isSubscribedToRecommendedColor,
                                disabled: savingSub
                              }]`
                              v-if="!!hairGoalRecs.grayCoverageProduct"
                              )
            RecommendedColor(:product="hairGoalRecs.grayCoverageProduct")
          RecommendationPanel(title="You mentioned wanting better <strong>gray coverage</strong>"
                              v-if="(!hairGoalRecs.grayCoverageProduct && hairGoalRecs.colorIssue == 'gray_coverage')"
                              )
            ContactColorist(message="We're sorry you didn't get enough gray coverage.  Our licensed colorists have tons of tips on how to cover stubborn grays.")
          RecommendationPanel(title="You mentioned wanting to try a <strong>different tone</strong>"
                              preamble="Hair gloss is a semi-permanent way to play with tones.  We recommend:"
                              :actions="recommendedGlossActions"
                              v-if="!!hairGoalRecs.differentToneProduct"
                              )
            RecommendedGloss(:product = "hairGoalRecs.differentToneProduct")
          RecommendationPanel(title="You mentioned wanting to try a <strong>different color</strong>"
                              actionsDescription="Or, try the following options at home..."
                              :actions='[ { label: "Explore more shades", inverted: true, action: exploreMoreShades } ]'
                              v-if = "(hairGoalRecs.colorIssue == 'different_color')")
            ContactColorist(message="Reach out for one-on-one help.  Our licensed colorists can recommend a <strong>new shade</strong>.")
          RecommendationPanel(title="You mentioned wanting to hear about <strong>hair trends &amp; styling tips</strong>"
                              preamble="<a href='blog/'>Our blog</a> has the latest hair color, care, and styling tricks"
                              :actions = '[ { label: "Read more", inverted: true, action: goToBlog } ]'
                              v-if="hairGoalRecs.trendsAndTips"
                              )
            RecommendedBlog(:blogArticle="blogArticle")

          .thanks-footer
            p.color-slate.thanks-message.text-center Thank you for talking hair with us!
            button.btn-reset.bold.upper.color-purple.xs-f-small.max-at-tweak(@click="goToViewAccount") View Your Account

</template>

<script>
  import Vue from 'vue';
  import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
  import vueCustomerSvc from '../../services/vueCustomerSvc';
  import vueProductSvc from '../../services/vueProductSvc';
  import ContactColorist from './ContactColorist';
  import RecommendedColor from './RecommendedColor';
  import RecommendedGloss from './RecommendedGloss';
  import RecommendedBlog from './RecommendedBlog';
  import RecommendationPanel from './RecommendationPanel';


  export default {
    name: "Recommendations",

    inject: ['getObjProperty'],

    components: {
        ContactColorist,
        RecommendedColor,
        RecommendedGloss,
        RecommendedBlog,
        RecommendationPanel
    },

    data() {
      return {
        blogArticle: {
          short_description: "How to Color the Back of Your Head in 6 Seriously Simple Steps",
          url: "blog/how-to-color-the-back-of-your-hair-in-6-seriously-simple-steps",
          alt_text: "How to Color the Back of Your Head in 6 Seriously Simple Steps",
          thumb_url: "https://mr-cdn.imgix.net/content/images/2018/10/jo4tv8gz-blog-how-to-color-the-back-of-your-head-1600x800/blog-how-to-color-the-back-of-your-head-1600x800.jpeg?w=374.9375&h=338.4375&fit=crop&crop=faces&dpr=1.7&q=50&auto=format"
        }
      }
    },

    computed: {
      subscriptionId() { return this.$route.query.subscriptionId },
      recommendedGlossId() { return this.getObjProperty(this.hairGoalRecs, "differentToneProduct.id") },
      recommendedColorId() { return this.getObjProperty(this.hairGoalRecs, "grayCoverageProduct.id") },

      ...mapGetters('cart', ['productIdInCart']),
      ...mapGetters('subscriptions', ['getSubById']),
      ...mapGetters('refillCart', ['productIdInRefillCart']),

      ...mapState('cart', ['cart', 'cartUpdated', 'addingProduct']),
      ...mapState('refillCart', ['refillCart', 'modifyingRefillProduct']),
      ...mapState('subscriptions', ['savingSub']),

      sub() { return this.getSubById(this.subscriptionId) },

      isSubscribedToRecommendedColor() { return this.sub.product_id == this.recommendedColorId },

      isRecInCart() { return this.cart.items && this.productIdInCart(this.recommendedGlossId) },

      isRecInNextShipment() { return this.productIdInRefillCart(this.recommendedGlossId) },

      recommendedGlossActions() {
        if(this.isRecInCart || this.isRecInNextShipment) {
          return [{
            label: "Added To " + (this.isRecInCart ? "Bag" : "Shipment"),
            checked: true,
            action: this.isRecInCart ? this.goToCart : this.goToNextShipment
          }];
        }

        return [{
          label: "Add to Bag",
          action: this.addRecToBag,
          disabled: Boolean(this.addingProduct)
        }, {
          label: "Add to next shipment",
          action: this.addRecToNextShipment,
          disabled: this.modifyingRefillProduct,
          inverted: true
        }];
      }
    },

    asyncComputed: {
      hairGoalRecs: {
        get() {
          return vueCustomerSvc.getHairGoalRecsBySubscriptionId(this.subscriptionId).then(res => res.data);
        },
        default: {}
      }
    },

    methods: {
      ...mapActions('subscriptions', ['initSubscriptions', 'updateSubscriptionColor']),
      ...mapActions('cart', ['addToCart', 'loadCart']),
      ...mapActions('refillCart', ['addToRefillCart', 'loadRefillCart', 'initRefillCart']),
      ...mapActions(['notifySuccess', 'notifyError']),
      ...mapActions('moreColorOptions', ['openPlaygroundModal']),

      exploreMoreShades() {
        this.trackMREvent('CFU explore more shades clicked');
        this.openPlaygroundModal({
          props: {
            viewOnModel: true,
            product:  { id: this.sub.product_id }
          }
        });
      },

      addRecToBag() {
        this.addToCart({
          productId: this.recommendedGlossId,
          ctaSource: 'CFU Recommendations',
          cartType: 'active'
        }).then(() => {
          this.notifySuccess("This item has been added to your bag.");
        }).catch(this.notifyError)
        .finally(this.loadCart);
      },

      addRecToNextShipment() {
        this.addToRefillCart({
          product_id: this.recommendedGlossId,
          ctaSource: 'CFU Recommendations',
          qty: 1
        }).then(this.loadRefillCart)
        .catch(this.notifyError);
      },

      goToBlog() {
        window.location = this.blogArticle.url;
      },

      goToManageSubscription() {
        window.location = `dashboard/purchases/edit-auto-delivery/${this.subscriptionId}`;
      },

      updateSubscription() {
        this.updateSubscriptionColor({
          subscriptionId: this.subscriptionId,
          productId: this.recommendedColorId
        }).then(this.goToManageSubscription);
      },

      goToViewAccount() {
        window.location = "dashboard/welcome";
      },

      goToCart() {
        window.location = "cart";
      },

      goToNextShipment() {
        window.location = "dashboard/welcome/nextShipment";
      }
    },

    created() {
      if(!this.subscriptionId || this.hairGoalRecs.quizAnswered === false) {
        window.location = "dashboard/welcome";
        return;
      }

      this.initSubscriptions();
      this.initRefillCart();
    },

    beforeMount() {
      if (this.cartUpdated === 0) {
        this.loadCart();
      }

      if(this.refillCartUpdated === 0) {
        this.loadRefillCart();
      }
    }
  }
</script>

<style scoped lang="stylus">
  .recommendations
    padding-top 1.5em
    padding-bottom 3em
    display inline-block

    .thanks-footer
      text-align center
      
      p
      button
        margin 1.2em

</style>
